import { redirect } from 'react-router-dom';
import authLoader from './authLoader';

const monitoringLoader = async () => {
	const { user } = await authLoader();
	if (!user.permissions.isSystemAdmin && !user.permissions.isMonitoring) {
		throw redirect('/');
	}
	return user;
};

export default monitoringLoader;
